import styled from "@emotion/styled/macro";
import { alpha } from "@mui/material/styles";
import isStyledPropsValid from "utils/isStyledPropsValid";
import { IconButton } from "@metacrm/metacrm-material-ui/dist/Button";
import CustomTabs from "components/CustomTabs/Tabs";
import Menu from "@mui/material/Menu";
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";

export const StyledWhiteContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => ({
  background: theme.customColors.white,
  padding: "20px",
  marginBottom: "60px",
  borderRadius: 8,
  width: "100%",
  ...sx,
}));

export const StyledCustomTabsContentContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  marginTop: "20px",
}));

export const StyledCustomTabsContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => {
  return {
    position: "relative",

    "& .MuiTab-root": {
      textTransform: "none",
    },

    "& .MuiTabs-root": {
      "& .MuiButtonBase-root": {
        maxWidth: "unset",
        minWidth: "unset",
        flexGrow: "unset",
        flexBasis: "auto",
        fontSize: "14px",
        lineHeight: 1,
        padding: `9.5px 15px`,
      },
    },
  };
});

export const StyledContainerTitle = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  width: "100%",
  padding: "8px 12px",
  display: "flex",
  alignItems: "center",
  fontSize: "14px",
  fontWeight: 700,
  color: theme.customColors.grey[700],
}));

export const StyledWhiteAccordion = styled(Accordion, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  background: theme.customColors.white,
  borderRadius: "8px",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
  border: `1px solid ${theme.customColors.grey[300]}`,
  "&:before": {
    display: "none",
  },
  "&.Mui-expanded": {
    margin: "auto",
  },
}));

export const StyledWhiteAccordionSummary = styled(AccordionSummary, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  padding: 0,
  paddingRight: "20px",
  margin: 0,
  display: "flex",
  alignItems: "center",
  "& > div": {
    margin: 0,
  },
}));

export const StyledTextButton = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => ({
  cursor: "pointer",
  backgroundColor: "transparent",
  padding: "4px",
  color: theme.customColors.purple[500],
  fontSize: "12px",
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  fontWeight: 700,
  "& .plus": {
    marginRight: "5px",
    fontWeight: 700,
    display: "flex",
  },
  ...sx,
}));
